// extracted by mini-css-extract-plugin
module.exports = {"alertTitle":"pre-close-table_alertTitle__Y7aTa","alertSubtitle":"pre-close-table_alertSubtitle__egBxd"};